import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import { ApplicationsService, HealthService } from '../api/user-portal-service';
import { APP_CONFIG } from '../common/constants';
import { queryKeys } from '../common/queryClient';
import type { UserApplication } from '../types/api.types';

/**
 * Hook to fetch user applications
 */
export function useApplications(
  options?: Omit<
    UseQueryOptions<UserApplication[], Error>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery({
    queryKey: queryKeys.applications.list(),
    queryFn: async () => {
      const response = await ApplicationsService.getUserApplications();
      // Extract items from paginated response and filter out user-portal
      const items = response.items ?? [];

      return items.filter(app => app.app_name !== APP_CONFIG.name);
    },
    ...options,
  });
}

/**
 * Hook to check API health
 */
export function useHealthCheck(
  options?: Omit<
    UseQueryOptions<Record<string, unknown>, Error>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery({
    queryKey: ['health'],
    queryFn: () => HealthService.getHealth(),
    staleTime: 30000, // 30 seconds
    ...options,
  });
}
